
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#56BFC7","clip-path":"url(#clip0_25476_43285)"}},[_c('path',{attrs:{"d":"M9.362.185a1.5 1.5 0 011.23.393l.012.01 3.21 3.21.01.012a1.5 1.5 0 01-.308 2.306L10.42 8.114l-1.016 4.253a1.11 1.11 0 01-1.838.529L1.41 6.73a1.1 1.1 0 01.532-1.834l.01-.002 4.294-.956L8.289.883A1.5 1.5 0 019.362.185zm.355 1.01a.5.5 0 00-.591.235l-2.16 3.23a.5.5 0 01-.307.21l-4.484.999a.1.1 0 00-.047.164l6.133 6.144a.11.11 0 00.174-.057l1.059-4.434a.5.5 0 01.215-.304l3.282-2.117a.5.5 0 00.11-.766L9.902 1.302a.5.5 0 00-.186-.107z"}}),_c('path',{attrs:{"d":"M5.192 9.177a.5.5 0 01.003.707l-4.09 4.12a.5.5 0 01-.71-.704l4.09-4.12a.5.5 0 01.707-.003z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_25476_43285"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.25 .152)","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    